export function replaceByDict(string: string, dict: {}) {
  for (const key in dict) {
    if (dict[key]) {
      const searchRegExp = new RegExp(`{${key}}`, 'gi')
      string = string.replace(searchRegExp, dict[key])
    }
  }

  return string
}
